import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { ObjectWithId, Topic, TopicListItem } from '@synergy/models';
import { noop } from '@synergy/utils';

import { TopicRequest } from './models/topic-request';

export class TopicsApi {
    constructor(protected baseUrl: string) {}

    public cget = async (params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<TopicListItem>>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/topics`, { params }),
            response => response.data
        );
    };

    public getAvailableTopicsForCustomer = async (customerId: number): Promise<ApiResult<TopicListItem[]>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/customers/${customerId}/available-topics`),
            response => response.data
        );
    };

    public getDetail = async (id: number): Promise<ApiResult<Topic>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/topics/${id}`),
            response => response.data
        );
    };

    public updateTopic = async (topic: TopicRequest & ObjectWithId): Promise<ApiResult<TopicListItem>> => {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/topics/${topic.id}`, topic),
            response => response.data
        );
    };

    public createTopic = async (topic: TopicRequest): Promise<ApiResult<TopicListItem>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/topics`, topic),
            response => response.data
        );
    };

    public deleteTopic = async (topicId: number): Promise<ApiResult> => {
        return safeRequest(() => request.delete(`${this.baseUrl}/topics/${topicId}`), noop);
    };
}
